import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  isSpinning = false;
  spinnerText: string;

  constructor() {}

  startSpinner(text: string) {
    if (this.isSpinning) {
      console.log('Spinner service already started');
      return;
    }

    // console.log('Spinner service started');
    this.isSpinning = true;
    this.spinnerText = text;
  }

  stopSpinner() {
    // console.log('Spinner service stopped');
    this.spinnerText = null;
    this.isSpinning = false;
  }
}
